/**
 * Count queries by status category
 * @param {Object} queriesByExpert - Object with expert data containing queries
 * @param {string[]} statusList - List of statuses to match
 * @returns {number} Count of matching queries
 */
export const countQueriesByStatus = (queriesByExpert, statusList) => {
  let count = 0;
  Object.values(queriesByExpert).forEach((expertData) => {
    // queriesByExpert values are { expert, queries: [] } objects
    const queries = expertData.queries || [];
    queries.forEach((query) => {
      if (statusList.includes(query.status)) {
        count++;
      }
    });
  });
  return count;
};

/**
 * Count external efforts by status category
 * @param {Array} externalEfforts - Array of external effort objects
 * @param {string[]} statusList - List of statuses to match
 * @returns {number} Count of matching efforts
 */
export const countExternalEffortsByStatus = (externalEfforts, statusList) => {
  return externalEfforts.filter((effort) => statusList.includes(effort.status?.toLowerCase())).length;
};

/**
 * Calculate status based on average percentage of quotas
 * @param {number} successful - Number of successful items
 * @param {number} successfulQuota - Quota for successful items
 * @param {number} submitted - Number of submitted items
 * @param {number} submittedQuota - Quota for submitted items
 * @returns {string|null} Status: 'risk', 'attention', 'onTrack', or null
 */
export const calculateStatus = (successful, successfulQuota, submitted, submittedQuota) => {
  if (!successfulQuota || !submittedQuota) {
    return null;
  }
  const successfulPercent = successful / successfulQuota;
  const submittedPercent = submitted / submittedQuota;
  const averagePercent = (successfulPercent + submittedPercent) / 2;

  if (averagePercent < 0.5) {
    return 'risk';
  } else if (averagePercent < 0.8) {
    return 'attention';
  }
  return 'onTrack';
};
